import { render, staticRenderFns } from "./bindWx.vue?vue&type=template&id=74e097fe&scoped=true&"
import script from "./bindWx.vue?vue&type=script&lang=js&"
export * from "./bindWx.vue?vue&type=script&lang=js&"
import style0 from "./bindWx.vue?vue&type=style&index=0&id=74e097fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e097fe",
  null
  
)

export default component.exports